import api, { isSuccessResponse } from "lib/api";
import { API_ENDPOINTS } from "lib/apiUrl";
import { UpdateAuthUserData } from "store/reducer";

export {
  getAvatarUrl,
  getProfileNames,
  getDisplayName,
  getInitials,
} from "lib/authUserDisplay";

export async function refreshAuthUser(dispatch) {
  const meResp = await api.get(API_ENDPOINTS.me);
  if (!isSuccessResponse(meResp)) {
    const msg =
      (meResp && typeof meResp === "object" && (meResp.message || meResp.error)) ||
      "Could not refresh your profile.";
    throw new Error(msg);
  }
  const root = meResp?.data ?? meResp ?? {};
  const nextUser =
    (root.user && typeof root.user === "object" ? root.user : null) ||
    (root.email || root.name || root.firstName || root.avatarUrl ? root : null);
  if (nextUser) {
    await dispatch(UpdateAuthUserData(nextUser));
  }
}
